import { render } from "./HasManySelect.vue?vue&type=template&id=36155af0"
import script from "./HasManySelect.vue?vue&type=script&lang=js"
export * from "./HasManySelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasManySelect.vue"]])

export default __exports__